import { track } from "../lib/track";

/**
 * `/dirigeant` quand l'axe est fermé depuis `/pilotage` — 09/10/2026.
 *
 * L'axe ne mesurait que les fonctions administratives et de gestion d'une
 * entreprise. Le porteur l'a retiré le temps de le reprendre. La page reste
 * servie, parce que des liens y mènent encore (annonces, partages, pages déjà
 * indexées) : elle dit qu'elle est fermée, renvoie vers le diagnostic de son
 * propre poste, et garde la voie de qui a déjà payé un rapport d'entreprise.
 */
export function DirigeantFerme() {
  return (
    <section id="contenu">
      <div className="shell narrow app">
        <div className="kicker">Dirigeants de PME</div>
        <h1 style={{ marginTop: "6px" }}>Le diagnostic dirigeant est fermé pour le moment</h1>
        <p className="sub">
          Nous le reprenons pour qu'il couvre tous les métiers d'une entreprise, et pas seulement
          l'administration et la gestion. Il rouvrira à cette même adresse.
        </p>

        <div className="block">
          <h2>Votre propre poste se mesure dès maintenant</h2>
          <p>
            Le diagnostic individuel reste ouvert : quelles de vos tâches une IA réalise déjà, et
            ce que ce temps vous coûte. Gratuit, sans inscription.
          </p>
          <a
            className="btn btn-brass"
            href="/"
            onClick={() => track("cta_click", { from: "dirigeant-ferme" })}
          >
            Faire le diagnostic de mon poste
          </a>
        </div>

        <div className="block">
          <h2>Vous avez déjà payé un rapport d'entreprise</h2>
          <p>
            Il reste disponible. Entrez la référence reçue au paiement sur la page d'aide.
          </p>
          <a className="lien-cible" href="/aide">
            Retrouver mon rapport
          </a>
        </div>
      </div>
    </section>
  );
}
